"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var NewsDetailController = /*#__PURE__*/function (_PageController) {
  function NewsDetailController() {
    var _this2;
    _classCallCheck(this, NewsDetailController);
    _this2 = _callSuper(this, NewsDetailController);
    _this2.imageCompilation = ".mceWrapper-imgCompilation";
    _this2.imageCompilationItem = ".wrapperImgCompilation-item";
    _this2.mceImage = ".mceImage";
    if (_this2.platform.isPhone() || _this2.platform.isTablet()) {
      _this2.initAnchorScroll(40);
    } else {
      _this2.initAnchorScroll(40);
    }
    _this2.initImageCompilation();
    _this2.initImagesLink();
    _this2.showFormPopover();
    return _this2;
  }
  _inherits(NewsDetailController, _PageController);
  return _createClass(NewsDetailController, [{
    key: "initImagesLink",
    value: function initImagesLink() {
      var _this = this;
      $(_this.mceImage).each(function () {
        if ($(this).parents("a").length == 0) {
          $(this).wrap('<a href="' + $(this).attr('src') + '" data-lightbox="image-1" ></a>');
        }
      });
    }
  }, {
    key: "showFormPopover",
    value: function showFormPopover() {
      $(document).on('click', '.showFormPopoverContact', function (e) {
        $('#formPopoverContact').modal();
        return false;
      });
      $(document).on('click', '.showFormPopoverMessage', function (e) {
        $('#formPopoverMessage').modal();
        return false;
      });
      $(document).on('click', '.showFormPopoverSubscribe', function (e) {
        console.log($(this).attr('data-mailchimp-tag'));
        $('#formPopoverSubscribe').modal();
        return false;
      });
    }
  }, {
    key: "initImageCompilation",
    value: function initImageCompilation() {
      console.log('init');
      var _this = this;
      _this.recalculateImageCompilation();
      $(window).resize(function () {
        $(_this.imageCompilationItem, $(_this.imageCompilation)).attr('style', '');
        $("img", $(_this.imageCompilation)).attr('style', '');
        _this.recalculateImageCompilation();
      });
    }
  }, {
    key: "recalculateImageCompilation",
    value: function recalculateImageCompilation() {
      var _this = this;
      var maxHeight = false;
      if (this.platform.isPhone()) {
        return false;
      }
      //recalculate optimal width
      $(_this.imageCompilation).each(function () {
        $("img", this).each(function () {
          var width = $(this).parents(_this.imageCompilationItem).width();
          $(this).attr('style', 'width: ' + width + 'px !important');
          $(this).parent(_this.imageCompilationItem).css('height', $(this).height());
        });
      });

      //recalculate optimal height
      $(_this.imageCompilation).each(function () {
        maxHeight = false;
        $("img", this).each(function () {
          maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
        });
        $("img", this).each(function () {
          $(this).parents(_this.imageCompilationItem).css('height', maxHeight);
          var styles = 'min-height: ' + maxHeight + 'px !important; max-height: ' + maxHeight + 'px !important;';
          $(this).attr('style', styles);
        });
      });
    }
  }]);
}(PageController);